<div class="error-wrapper">
    <div class="container">
        <img class="img-100" src="assets/images/other-images/sad3.gif" alt="">
        <div class="error-heading">
            <h2 class="headline font-danger">404</h2>
        </div>
        <div class="col-md-8 offset-md-2">
            <p class="sub-content">
                The page you are attempting to reach is currently not available.
                This may be because the page does not exist or has been moved.
            </p>
        </div>
        <div>
            <button class="btn btn-primary btn-lg" (click)="navigateToHome()">BACK TO HOME PAGE</button>
        </div>
    </div>
</div>